import { Component } from '@angular/core';

@Component({
  selector: 'black-features-section',
  templateUrl: './features-section.component.html',
  styleUrls: ['./features-section.component.css'],
  standalone: true,
  imports: [],
})
export class FeaturesSectionComponent {}
